import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { C } from '../../theme/palette';

/** D'où vient une alerte, dit en clair. */
const ORIGINES = {
  lecture: ['Lu dans le document', C.red, C.redL],
  texte: ['Mot repéré — à vérifier', C.amber, C.amberL],
  structure: ['Structure des postes', C.navy, C.navyXL],
};

/**
 * Rapport de vigilance : chaque piège de la soumission, en clair, avec la
 * phrase qui le porte et l'endroit où elle se lit.
 *
 * @param {object} props
 * @param {object[]} props.alertes alertes du document
 * @param {boolean} props.controleTexte vrai si le texte a aussi été relu par mots-clés
 * @returns {import('react').ReactElement} la carte
 */
export function RapportVigilance({ alertes, controleTexte }) {
  return (
    <Card style={{ marginBottom: 12 }}>
      <Bar
        icon="⚠️"
        title="Rapport de vigilance"
        color={C.red}
        sub={
          (alertes.length
            ? alertes.length + ' point(s) à lire avant de chiffrer'
            : 'Aucun piège relevé') +
          (controleTexte ? '' : ' · document photographié : pas de contrôle par mots-clés')
        }
      />
      <div style={{ padding: 12 }} role="list" aria-label="Rapport de vigilance">
        {alertes.length === 0 && (
          <div style={{ fontSize: 10.5, color: C.muted, lineHeight: 1.6 }}>
            Rien de particulier n'a été relevé. Relisez tout de même les conditions particulières
            (CAN 102) et la page de garde.
          </div>
        )}
        {alertes.map((a, i) => {
          const [origine, couleur, fond] = ORIGINES[a.origine] || ORIGINES.lecture;
          return (
            <div
              key={a.type + i}
              role="listitem"
              style={{
                borderLeft: '3px solid ' + couleur,
                background: fond,
                borderRadius: 8,
                padding: '9px 11px',
                marginBottom: 8,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                <b style={{ fontSize: 11.5, color: C.ink }}>{a.titre}</b>
                <span style={{ fontSize: 8.5, color: couleur, fontWeight: 700 }}>{origine}</span>
              </div>
              <div style={{ fontSize: 10, color: C.grey, marginTop: 3, lineHeight: 1.5 }}>
                {a.explication}
              </div>
              {a.citation && (
                <blockquote
                  style={{
                    margin: '6px 0 0',
                    fontSize: 10,
                    fontStyle: 'italic',
                    color: C.ink,
                    lineHeight: 1.5,
                  }}
                >
                  « {a.citation} »{a.emplacement ? ' — ' + a.emplacement : ''}
                </blockquote>
              )}
              {a.reference && (
                <div style={{ fontSize: 8.5, color: C.muted, marginTop: 4 }}>
                  Réf. {a.reference}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
